import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 44, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-8%" }}
    transition={{ duration: 0.95, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

// A single line that slides up from behind a mask.
export const MaskLine = ({ children, delay = 0, className = "", duration = 1 }) => (
  <span className="block overflow-hidden">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "115%" }}
      whileInView={{ y: 0 }}
      viewport={{ once: true, margin: "-6%" }}
      transition={{ duration, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

// Load-time variant (no scroll trigger) for the hero.
export const MaskLineLoad = ({ children, delay = 0, className = "", duration = 1.05 }) => (
  <span className="block overflow-hidden">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);
